import { useEffect } from "react";
import { useHydrated } from "remix-utils/use-hydrated";

export default function ExternalScripts({
  scripts,
}: {
  scripts: Array<
    {
      id: string;
      async?: boolean;
      type?: string;
      insertToHead?: boolean;
      notIdPrefix?: boolean;
    } & ({ innerHTML: string } | { src: string })
  >;
}) {
  const isHydrated = useHydrated();

  useEffect(() => {
    if (!isHydrated) {
      return;
    }
    scripts.forEach((script) => {
      const id = script.notIdPrefix ? script.id : `__script_${script.id}`;
      if (document.getElementById(id)) {
        return;
      }
      const scriptElement = document.createElement("script");
      scriptElement.id = id;
      scriptElement.async = script.async ?? false;
      scriptElement.type = script.type ?? "text/javascript";
      if ("src" in script) {
        scriptElement.src = script.src;
      } else {
        scriptElement.innerHTML = script.innerHTML;
      }
      if (script.insertToHead) {
        document.head.append(scriptElement);
      } else {
        document.body.prepend(scriptElement);
      }
    });
  }, [isHydrated, scripts]);
  return null;
}
